import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const FilterSettings: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.33928 4.89279C4.1973 4.89279 4.89286 4.19723 4.89286 3.33922C4.89286 2.4812 4.1973 1.78564 3.33928 1.78564C2.48127 1.78564 1.78571 2.4812 1.78571 3.33922C1.78571 4.19723 2.48127 4.89279 3.33928 4.89279Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.89285 3.33936H14.2143"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 9.55343C8.85801 9.55343 9.55357 8.85788 9.55357 7.99986C9.55357 7.14184 8.85801 6.44629 8 6.44629C7.14198 6.44629 6.44643 7.14184 6.44643 7.99986C6.44643 8.85788 7.14198 9.55343 8 9.55343Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.78571 8H6.44643"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.55357 8H14.2143"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.6607 14.2141C13.5187 14.2141 14.2143 13.5185 14.2143 12.6605C14.2143 11.8025 13.5187 11.1069 12.6607 11.1069C11.8027 11.1069 11.1071 11.8025 11.1071 12.6605C11.1071 13.5185 11.8027 14.2141 12.6607 14.2141Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.1071 12.6606H1.78571"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
